import { render, staticRenderFns } from "./EditDeviceCate.vue?vue&type=template&id=07f856f8&scoped=true"
import script from "./EditDeviceCate.vue?vue&type=script&lang=js"
export * from "./EditDeviceCate.vue?vue&type=script&lang=js"
import style0 from "./EditDeviceCate.vue?vue&type=style&index=0&id=07f856f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f856f8",
  null
  
)

export default component.exports